var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"comp-horizontal-navigation mb-3"},_vm._l((_vm.options),function(o,k){return _c('router-link',{key:'nav_' + o.text + '_option_' + k + '_' + _vm._uid,staticClass:"opt",attrs:{"to":o.uri}},[_vm._v(" "+_vm._s(o.text)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }